import { get, post } from '../core/http';

export interface AssistantQaItem {
  answerContent?: string;
  id?: number;
  questionContent?: string;
}

export interface AssistantAnswerSourceParams {
  question: string;
}

export interface AssistantPresetQuestionParams {
  qaId: number;
}

export interface AssistantFeedbackPayload {
  feedback?: boolean;
  historyId?: number;
  reason?: string;
}

export interface AssistantUpdateAskHistoryPayload {
  answer?: string;
  historyId?: number;
}

export const assistantApi = {
  getPresetQuestions(params: AssistantPresetQuestionParams) {
    return get<AssistantQaItem[], AssistantPresetQuestionParams>(
      '/assistant/front/get/presetQuestion',
      params,
    );
  },

  getAnswerSource(params: AssistantAnswerSourceParams) {
    return get<boolean, AssistantAnswerSourceParams>('/assistant/front/answerSource', params);
  },

  updateAskHistory(data: AssistantUpdateAskHistoryPayload) {
    return post<string, AssistantUpdateAskHistoryPayload>(
      '/assistant/front/updateAskHistory',
      data,
    );
  },

  submitFeedback(data: AssistantFeedbackPayload) {
    return post<string, AssistantFeedbackPayload>('/assistant/front/feedback', data);
  },

  submitFeedbackReason(data: AssistantFeedbackPayload) {
    return post<string, AssistantFeedbackPayload>('/assistant/front/reasonBack', data);
  },
};
